import React from "react";
import { Text } from "rebass";

export const TXT_TIMES_MESSAGE =
  "TXT messages are only sent before 10pm and after 7am";
export const NotificationTimesMessage = () => (
  <Text as="p">{TXT_TIMES_MESSAGE}</Text>
);
